import { Injectable } from '@angular/core';
import { IPaetepCfGenericMapperService } from '../../interfaces/paetep-cf-generic-mapper.service';
import { MultiLineTextAnswerConfig } from 'src/app/model/observation/custom-forms/answer-configs/multi-line-text-answer-config.model';
import { EdlCfAnswerMultiLineTextModel, EdlCfGenericModel, EdlCfMultiLineTextModel, MAX_PREFILL_LENGTH, MAX_TITLE_LENGTH } from '@edl-development/edl-custom-forms';
import { CustomFormQuestionDisplayDTO } from 'src/app/model/observation/custom-forms/custom-form-question-dto.model';
import { CustomFormQuestionType } from 'src/app/model/enum/observations/custom-forms/custom-form-question-type.enum';
import { CustomFormsHelpersService } from '../../custom-forms-helpers/custom-forms-helpers.service';

@Injectable({
    providedIn: 'root'
})
export class PaetepCfMultiLineTextMapperService 
    implements IPaetepCfGenericMapperService<MultiLineTextAnswerConfig, EdlCfMultiLineTextModel, string, EdlCfAnswerMultiLineTextModel> {

    constructor(private customFormsHelpersService: CustomFormsHelpersService) { }

    public toEdlModel = (child: CustomFormQuestionDisplayDTO<MultiLineTextAnswerConfig>): EdlCfMultiLineTextModel => {
        return {
            title: child.label,
            prefill: child?.answerConfig?.prefill ?? '',
            isRequired: child.required
        }
    }

    public toPaetepModel = ({
        formID, 
        sectionID,
        displayOrder,
        groupOrder,
        question
    } : {
        formID: string, 
        sectionID: string, 
        displayOrder: number,
        groupOrder: number,
        question: EdlCfGenericModel<EdlCfMultiLineTextModel>
    }): CustomFormQuestionDisplayDTO<MultiLineTextAnswerConfig> =>  {
        return this.customFormsHelpersService.createCustomFormQuestion<MultiLineTextAnswerConfig>({
            $type: CustomFormQuestionType.MULTI_LINE_TEXT,
            typeID: CustomFormQuestionType.MULTI_LINE_TEXT,
            formID,
            sectionID,
            questionID: question.id,
            readOnly: false,
            required: question.config.isRequired,
            displayOrder,
            groupOrder,
            label: (question.config.title ?? '').substring(0, MAX_TITLE_LENGTH),
            displayLabel: true,
            answerConfig: {
                prefill: (question.config.prefill ?? '').substring(0, MAX_PREFILL_LENGTH)
            }
        });
    }

    public toEdlAnswer = (answer: string = '', question: CustomFormQuestionDisplayDTO<MultiLineTextAnswerConfig>) => answer;
}
